module.exports = __webpack_public_path__ + "media/assets/images/logo_nexa-9289e636d3e18adce4587bfcff96d4b2.png";